<template>
        <div
         class="text-center cursor-pointer"
        >
            <q-avatar
              size="86px"
              color="grey-3"
              text-color="grey-6"
            >
              <q-img
                v-if="face && face.imageUrl"
                :src="face.imageUrl"
                :ratio="1"
                fit="cover"
              />
              <q-icon
                v-else
                name="fa fa-user-circle"
                size="86px"
              />
              <q-tooltip :delay="300">
                <div>{{ label }}</div>
                <div v-if="personFaceCount" class="text-caption">
                  {{ personFaceCount }}
                  {{ personFaceCount === 1 ? 'face' : 'faces' }}
                </div>
              </q-tooltip>
            </q-avatar>
        </div>
</template>

<script lang="ts">
import { Face } from '@/analysis/types';
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    face: {
      type: Object as () => Face,
      required: true,
    },
  },
  computed: {
    label(): string {
      if (this.face.person && this.face.person.label) {
        return this.face.person.label;
      }
      return 'Unknown';
    },
    personFaceCount(): number | null {
      if (this.face.person && this.face.person.faceCount !== undefined) {
        return this.face.person.faceCount;
      }
      return null;
    },
  },
});
</script>
